// ANCHOR React
import React, { memo } from 'react';

// ANCHOR Models
import { CourseCardData } from '@lyon/scoped-models/CourseCardData';

// ANCHOR Components
import { ImageBadge } from '@lyon/components/utils/ImageBadge';
import { BadgeColor } from '@lyon/components/utils/ImageBadge/styles';

export const LyonCourseCardPurchased = memo(() => {
  const [isFree, myCourse] = CourseCardData.useSelectors((state) => [
    state.data?.price === 0,
    state.myCourse,
  ]);

  // TODO Add api for checking if user has already bought the course
  const isCoursePurchased = false;

  if (!myCourse && isCoursePurchased) {
    return (
      <ImageBadge color={BadgeColor.positive}>
        purchased
      </ImageBadge>
    );
  }

  if (isFree) {
    return (
      <ImageBadge color={BadgeColor.inversePrimary}>
        free
      </ImageBadge>
    );
  }

  return null;
});
